module.exports = __webpack_public_path__ + "static/media/ABBOTT-LOGO.7db64757.jpg";